var baseStyle = {
  '.tqc-collapse': {
    maxHeight: 'unset'
  },
  container: {
    boxShadow: "0px 0px 12px -8px rgba(0,0,0,0.35)",
    borderRadius: 'sm'
  },
  header: {
    backgroundColor: 'white',
    borderBottom: '1px',
    borderTopLeftRadius: 'sm',
    borderTopRightRadius: 'sm',
    borderBottomRightRadius: 0,
    borderBottomLeftRadius: 0,
    '&[data-open="true"]': {
      backgroundColor: 'grey.100'
    },
    button: {
      alignSelf: 'flex-start',
      marginLeft: '28.5px',
      borderRadius: 'sm',
      _focus: {
        boxShadow: "0 0 0.1875rem 0.125rem #2182EB"
      },
      svg: {
        stroke: 'blue.600'
      }
    }
  },
  panel: {
    borderBottomLeftRadius: 'sm',
    borderBottomRightRadius: 'sm',
    px: 6,
    py: 4
  }
};
export var Accordion = {
  baseStyle
};